import { styled } from '@storybook/theming';

export const PostHeader = styled.header`
  margin-bottom: 8px;
`;
